import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";
const radioData = window.location.host.split(".");

const API = process.env.REACT_APP_MICRO_STREAM_URL;

export const getRadioByName = () => async (dispatch) => {
  await axios
    .get(`${API}/radio/name/${radioData[0]}`)
    .then(async (response) => {
      await dispatch({
        type: "GET_RADIO_NAME",
        data: response.data.data,
      });
      localStorage.setItem("radio_id", response.data.data.id);
      localStorage.setItem("radio_pack", response.data.data.pack.id);
      return response;
    });
};
export const change_playlist_at = (info) => {
  const userData = JSON.parse(localStorage.getItem("userData")) || {};
  axios.post(`${API}/history/change_playlist_at`, {
    ...info,
    user: userData.id,
  });
};
export const cancel_playlist_at = (info) => {
  const data = {
    started_at: info.x,
    time_sec: info.y,
  };
  axios.post(`${API}/history/cancel_playlist_at`, data);
};
export const reloadServer = (radio_id) => (dispatch) => {
  axios
    .post(`${API}/radio/reload/${radio_id}`)
    .then((res) => {
      handleSuccessOne(res.data?.message);
    })
    .catch((err) => {
      handleErrorOne(err.response?.data?.message);
    });
};
export const editRadioInfo = (id, info) => (dispatch) => {
  const FormData = require("form-data");
  const data = new FormData();
  typeof info.profile_picture === "object" &&
    data.append("profile_picture", info.profile_picture);
  typeof info.cover_picture === "object" &&
    data.append("cover_picture", info.cover_picture);

  info.latitude && data.append("latitude", info.latitude);
  info.latitude && data.append("longitude", info.longitude);

  axios
    .patch(`${API}/radio/info/${id}`, data)
    .then((response) => {
      dispatch(getRadioByName());
      dispatch({
        type: "EDIT_RADIO_SUCCESS",
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_RADIO_FAIL",
          payload: err.response.data?.message,
        });
        const timeoutId = setTimeout(() => {
          dispatch({
            type: "EDIT_RADIO_FAIL",
            payload: null,
          });
        }, 3000);
        clearTimeout(timeoutId);
      }
    });
};
